import styled from "styled-components";

const PerformanceAnalysis = ({ answersFeedback }) => {

    return (
        <Container>
            <h1>Análisis de tu desempeño</h1>
            <section>
                <span>
                    <label>
                        Análisis general
                    </label>
                    <p>
                        { answersFeedback?.ai_feedback?.general_analysis }
                    </p>
                </span>
                <span>
                    <label>
                        Fortalezas
                    </label>
                    <ul>
                        {answersFeedback?.ai_feedback?.strengths.map(strength => (
                            <li key={strength}>
                                {strength}
                            </li>
                        ))}
                    </ul>
                </span>
                <span>
                    <label>
                        Áreas para mejorar
                    </label>
                    <ul>
                        {answersFeedback?.ai_feedback?.improvement_areas.map(improvement_area => (
                            <li key={improvement_area}>
                                {improvement_area}
                            </li>
                        ))}
                    </ul>
                </span>
                <span>
                    <label>
                        Observaciones adicionales
                    </label>
                    <ul>
                        {answersFeedback?.ai_feedback?.observations.map(observation => (
                            <li key={observation}>
                                {observation}
                            </li>
                        ))}
                    </ul>
                </span>
            </section>
        </Container>
    )
}

export default PerformanceAnalysis;

const Container = styled.div`
    width: calc(100% - 48px);
    height: fit-content;
    border-radius: 30px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    gap: 24px;

    @media (width < 1000px) {
        width: 100%;
    }

    h1 {
        width: 100%;
        text-align: start;
        font-weight: 700;
        color: #1D1D18;
    }

    section {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;

        @media (width < 1000px) {
            grid-template-columns: repeat(1, 1fr);
        }

        span {
            display: flex;
            flex-direction: column;
            justify-content: start;
            align-items: start;
            gap: 1rem;

            label {
                font-size: 18px;
                font-weight: 700;
                color: #b31d15;
            }

            p {
                font-size: 16px;
                font-weight: 500;
            }

            ul {
                margin-left: 1rem;
                display: flex;
                flex-direction: column;
                justify-content: start;
                align-items: start;
                gap: 1rem;
            }

            li {
                font-size: 16px;
                font-weight: 500;
            }
        }
    }
`